import { Box, Stack, styled } from '@mui/material'
import LoanCalendarTablePrimaryActions from './LoanCalendarTablePrimaryActions'
import LoanCalendarTableSecondaryActions from './LoanCalendarTableSecondaryActions'

const ToolbarContainer = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  backgroundColor: theme.palette.background.paper,
  zIndex: 4,
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(1),
  flexDirection: 'column',
  alignItems: 'stretch',
  display: 'flex',
}))

const LoanCalendarTableToolbar = () => {
  return (
    <ToolbarContainer>
      <Stack flexDirection="row" gap={1} justifyContent="space-between">
        <LoanCalendarTablePrimaryActions />
        <LoanCalendarTableSecondaryActions />
      </Stack>
    </ToolbarContainer>
  )
}

export default LoanCalendarTableToolbar
